class DbsliceData { }

export let dbsliceData = new DbsliceData();



